import type { Story } from '@/store/story-types'

export const PROJECT_TRACKER_NEW3_STORY: Story = {
  id: 'project-tracker-new3',
  name: 'ProjectFlow — Project Tracker',
  narrative: 'A project management app with Kanban board, timeline with milestone progress, team workload view, task detail editing, and status filter tabs. Light theme with blue accents.',
  goals: ['Manage tasks on Kanban board', 'Track project timeline and milestones', 'View team workload distribution', 'Edit task details and update status'],
  lifecycle: 'ready',
  pages: [
    { id: 'pg-board', title: 'Board', order: 0, status: 'completed', elementCount: 7, linkedPageId: 'board', description: 'Kanban board with task cards organized by status columns' },
    { id: 'pg-timeline', title: 'Timeline', order: 1, status: 'completed', elementCount: 5, linkedPageId: 'timeline', description: 'Project timeline with milestones and progress indicators' },
    { id: 'pg-team', title: 'Team', order: 2, status: 'completed', elementCount: 5, linkedPageId: 'team', description: 'Team workload view with member assignments and capacity' },
  ],
  bddScenarios: [
    {
      id: 'bdd-1', name: 'View Kanban Board',
      description: 'User views the project Kanban board',
      steps: [
        { type: 'given', text: 'the user opens the project tracker' },
        { type: 'when', text: 'the board page loads' },
        { type: 'then', text: 'task cards are organized in status columns (To Do, In Progress, Done)', linkedPageId: 'board' },
      ],
    },
    {
      id: 'bdd-2', name: 'Move Task',
      description: 'User moves a task between columns',
      steps: [
        { type: 'given', text: 'the user is on the board view', linkedPageId: 'board' },
        { type: 'when', text: 'they drag a task card to another column' },
        { type: 'then', text: 'the task status is updated and card moves to the new column', linkedFlowId: 'updateTaskStatus' },
      ],
    },
    {
      id: 'bdd-3', name: 'View Timeline',
      description: 'User views the project timeline',
      steps: [
        { type: 'given', text: 'the user navigates to the timeline tab' },
        { type: 'when', text: 'the timeline page loads' },
        { type: 'then', text: 'milestones and progress bars are displayed', linkedPageId: 'timeline' },
      ],
    },
    {
      id: 'bdd-4', name: 'View Team Workload',
      description: 'User checks team workload distribution',
      steps: [
        { type: 'given', text: 'the user navigates to the team tab' },
        { type: 'when', text: 'the team page loads' },
        { type: 'then', text: 'team members with their assignments and capacity are shown', linkedPageId: 'team' },
      ],
    },
  ],
}
